import { render, staticRenderFns } from "./course_introduce.vue?vue&type=template&id=5ea7d807&scoped=true&"
import script from "./course_introduce.vue?vue&type=script&lang=js&"
export * from "./course_introduce.vue?vue&type=script&lang=js&"
import style0 from "./course_introduce.vue?vue&type=style&index=0&id=5ea7d807&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea7d807",
  null
  
)

export default component.exports